// The question modes.
export const QUESTION_MODE_NEW = 'new';
export const QUESTION_MODE_UPDATE = 'update';
